import { uniqueKeyGenerator, FileModel } from '@kunlun/dependencies';

export class FileHelper {
  public static fetchFilename(s: string): string {
    let fullFilename;
    try {
      fullFilename = new URL(s).pathname.split('/').pop()!;
    } catch (e) {
      console.error(e);
      return '';
    }
    const pi = fullFilename.lastIndexOf('.');
    let filename: string;
    if (pi === -1) {
      filename = fullFilename;
    } else {
      filename = fullFilename.substring(0, pi);
    }
    const si = filename.lastIndexOf('_');
    if (si !== -1) {
      if (pi === -1) {
        return `${filename.substring(0, si)}`;
      }
      return `${filename.substring(0, si)}.${fullFilename.substring(pi + 1, fullFilename.length)}`;
    }
    return filename;
  }

  public static normalizeFileList(list: any[]): FileModel[] {
    const finalList: FileModel[] = [];
    list.forEach((v) => {
      if (!v) {
        return;
      }
      if (typeof v === 'string') {
        finalList.push({
          id: uniqueKeyGenerator(),
          name: decodeURIComponent(FileHelper.fetchFilename(v)),
          url: v,
          uid: `${Date.now()}${Math.random() * 1000}`
        });
      } else if (v.url) {
        finalList.push({
          ...v,
          // antdv@3.2.14版，图片类型的上传，type属性有值都会识别为普通文件，这样就不会出现预览图
          type: null,
          id: v.id || uniqueKeyGenerator(),
          name: v.name || decodeURIComponent(FileHelper.fetchFilename(v.url))
        });
      }
    });
    return finalList;
  }
}
